import Tenants from "Features/Tenants/tenants.index";
import Authentication from "../Features/Auth";
import MainLayout from "Layout/layout.index";
import { IPrivateRoutes } from "./types";
import Organizations from "Features/Organizations/organization.index";
import Users from "Features/Users/users.index";
import PaddleProducts from "Features/SubscriptionConfiguration/PaddleProducts/paddleProducts.index";
import AddEditPaddleProductPage from "Features/SubscriptionConfiguration/PaddleProducts/AddEditPaddleProductPage/AddEditPaddleProductPage.index";
import AddPriceToProductPage from "Features/SubscriptionConfiguration/PaddleProducts/AddPriceToProductPage/AddPriceToProductPage.index";
import ProductPricesPage from "Features/SubscriptionConfiguration/PaddleProducts/ProductPricesPage/ProductPricesPage.index";
import ExceptionLog from "Features/Exceptions/Exceptions.index";
import AddEditLicensePage from "Features/Tenants/LicenseManagement/AddEditLicensePage";

export const PRIVATE_ROUTES: IPrivateRoutes[] = [
  {
    path: "/tenants/:tenantId/license",
    element: AddEditLicensePage,
    layout: MainLayout,
  },
  {
    path: "/tenants",
    element: Tenants,
    layout: MainLayout,
  },
  {
    path: "/organizations",
    element: Organizations,
    layout: MainLayout,
  },
  {
    path: "/users",
    element: Users,
    layout: MainLayout,
  },
  {
    path: "/payment-products",
    element: PaddleProducts,
    layout: MainLayout,
  },
  {
    path: "/payment-products/add",
    element: AddEditPaddleProductPage,
    layout: MainLayout,
  },
  {
    path: "/payment-products/edit/:productId",
    element: AddEditPaddleProductPage,
    layout: MainLayout,
  },
  {
    path: "/payment-products/:productId/prices",
    element: ProductPricesPage,
    layout: MainLayout,
  },
  {
    path: "/payment-products/:productId/add-price",
    element: AddPriceToProductPage,
    layout: MainLayout,
  },
  {
    path: "/payment-products/:productId/edit-price/:priceId",
    element: AddPriceToProductPage,
    layout: MainLayout,
  },
  {
    path: "/exceptions",
    element: ExceptionLog,
    layout: MainLayout,
  },
];

export const PUBLIC_ROUTES = [
  {
    path: "/",
    element: Authentication,
  },
];
